import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import {
    AccessibilityScanExclusion,
    ScanExclusionDomainsIds,
} from '@client/app/feature-modules/admin/modules/admin-scan-exclusions/types/scan-exclusions.type';
import { CollectionInterface } from '@monsido/angular-shared-components';
import { DEFAULT_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { DEFAULT_PAGE } from '@client/app/shared-modules/api/constants/page.constant';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';

@Injectable({
    providedIn: 'root',
})
export class AccessibilityScanExclusionsRepo {
    constructor (
        private apiService: ApiService,
    ) {
    }

    getAccessibilityScanExclusions (scanExcludeId: AccessibilityScanExclusion['id']): Promise<AccessibilityScanExclusion> {
        return this.apiService.get('accessibility/source_code_excludes/' + scanExcludeId, undefined, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    getAllAccessibilityScanExclusions (
        params: BaseRepoRequestType = { page: DEFAULT_PAGE, page_size: DEFAULT_PAGE_SIZE },
    ): Promise<CollectionInterface<AccessibilityScanExclusion>> {
        return this.apiService.get<CollectionInterface<AccessibilityScanExclusion>>('accessibility/source_code_excludes', params, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    createAccessibilityScanExclusions (model: AccessibilityScanExclusion): Promise<AccessibilityScanExclusion> {
        return this.apiService.post('accessibility/source_code_excludes', model, contextTokens.REDESIGN_ERROR_ALERT).then((obj: unknown) => {
            const created = obj as AccessibilityScanExclusion;
            if (model?.domains?.length) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.addAccessibilityScanExclusionDomains(created.id, { ids: model.domains, exclude_id: created.id! });
            }
            return created;
        });
    }

    updateAccessibilityScanExclusions (model: AccessibilityScanExclusion): Promise<void> {
        return this.apiService.patch('accessibility/source_code_excludes/' + model.id, model, undefined, contextTokens.REDESIGN_ERROR_ALERT).then(() => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.addAccessibilityScanExclusionDomains(model.id, { ids: model.domains, exclude_id: model.id! });
        });
    }

    getAccessibilityScanExclusionDomains (scanExcludeId: AccessibilityScanExclusion['id']): Promise<Array<{ id: number }>> {
        return this.apiService.get<Array<{ id: number }>>('accessibility/source_code_excludes/' + scanExcludeId + '/domains', undefined, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    addAccessibilityScanExclusionDomains (scanExcludeId: AccessibilityScanExclusion['id'], domains: ScanExclusionDomainsIds): Promise<void> {
        return this.apiService.patch('accessibility/source_code_excludes/' + scanExcludeId + '/domains', domains, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    destroyAccessibilityScanExclusions (scanExcludeId: AccessibilityScanExclusion['id']): Promise<void> {
        return this.apiService.delete('accessibility/source_code_excludes/' + scanExcludeId, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }
}
